'use strict';

const _ = require('lodash');

function ErrorPageController ($scope, IntercomService, $window, $state, $http, Flux, IdentityService, AnalyticsService) {

  const vm = this;
  const user = IdentityService.getUser();
  const supportSite = '//support.skycatch.com/hc/en-us/categories/201644828-Skycatch-Dashboard';
  const PlanStore = Flux.Store.get('PlanStore');
  const OrganizationStore = Flux.Store.get('OrganizationStore');

  const uploaderSite = IdentityService.get('uploadUrl');
  let uploaderToken = '';

  vm.brandConfig = OrganizationStore.getBrandConfig();

  vm.canPlanChat = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  vm.hasMultipleOrganizations = user && user.organizations ? user.organizations.length > 1 : false;
  vm.isBetaUser = IdentityService.isBetaUser();
  vm.hasEnabledPlan = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled;

  vm.openChat = () => {

    IntercomService.show();
  };

  vm.openSupport = () => {

    $window.open(supportSite, '_blank');
  };

  vm.goToSettings = () => {

    $state.go('settings.myProfile');
  };

  vm.changeOrg = () => {

    $state.go('select-organization');
  };

  vm.logout = () => {

    $state.go('logout', {}, {
      location: false
    });
  };

  vm.convertToSubscription = () => {
    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // Disabled
    // const subscription = PlanStore.get('externalSubscription');
    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
    //   'remaining_days': (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24),
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  vm.updateUploaderUrl = () => {

    const url = IdentityService.getAuthApiUri() + '/sso';

    const httpConfig = {
      url: url,
      method: 'POST'
    };

    return $http(httpConfig)
    .then((payload) => {

      const data = payload.data.data;
      uploaderToken = data.token;
    })
    .catch((payload, status) => {

      console.warn('SSO fetch failed', payload, status);
    });
  };

  vm.toggleUploader = _.debounce(() => {

    // TODO: Replace with iframe
    AnalyticsService.track('[CORE] Navigate', 'Uploader', {});
    let url;

    if (uploaderToken) {
      url = uploaderSite + '/login?token=' + uploaderToken + '&orgId=' + IdentityService.get('currentOrganization').id;
    }
    else {
      url = uploaderSite;
    }

    $window.open(url, '_blank');
  }, 0);

  vm._handlePlanStoreChange = _.debounce(() => {

    const customer = PlanStore.get('externalCustomer');
    const subscription = PlanStore.get('externalSubscription');
    vm.hasEnabledPlan = PlanStore.get('orgPlan').isEnabled;
    if (subscription) {
      vm.daysLeft = (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24);
      if (subscription.status === 'in_trial' && customer.card_status !== 'valid') {
        vm.planUpsellState = true;
      }
      else if (subscription.status === 'cancelled') {
        vm.daysLeft = 0;
        vm.planUpsellState = true;
      }
      else {
        vm.planUpsellState = false;
      }
    }

    vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  }, 900);

  vm.updateUploaderUrl();

  PlanStore.on(PlanStore.Events.Changed, vm._handlePlanStoreChange.bind(vm), $scope);
}

ErrorPageController.$inject = ['$scope', 'IntercomService', '$window', '$state', '$http', 'sbFlux', 'IdentityService', 'AnalyticsService'];
module.exports = ErrorPageController;



// WEBPACK FOOTER //
// ./src/app/dash/error/ErrorPageController.js